<template>
    <div>
        <div class="s_1280">
            <nav class="navbar wrapper navbar-expand-md fixed-top">
                <div class="col-4">
                    <router-link to="/home">
                        <img class="logo-img" id="logo-btn" src="images/logo.png" />
                    </router-link>
                </div>
                <div class="col-8">
                    <div class="app navigation">
                        <TopMenu></TopMenu>
                    </div>
                </div>
            </nav>
            <div class="main app">
                <div class="container-fluid wrapper">
                    <div class="row reg-box">
                        <div class="col-3">
                            <div class="left-bg">
                                <div class="left-links">
                                    <label class="done">Payment</label>
                                    <label class="active" href="#">Visa Form</label>
                                    <label class="passive" href="#">Documents</label>
                                </div>
                            </div>
                        </div>

                        <div class="col-8 offset-md-1">
                            <div class="reg-form payment top124">
                                <div class="reg-completed">
                                    <div class="form-group">
                                        <div class="payment-box bt48">
                                            <h3>
                                                The payment is not approved. Refer to card issuer
                                            </h3>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-sm-12 submit-row">
                                            <router-link to="/prepayment">
                                                <button type="button" class="btn btn-primary">Try again</button>
                                            </router-link>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <router-link to="/home">
                                <img class="logo-img" id="logo-btn" src="images/logo.png" />
                            </router-link>
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 top64">
                    <div class="left-links hrz-menu">
                        <label class="done">Registration</label>
                        <label class="active">Payment</label>
                        <label class="passive" href="#">Visa Form</label>
                        <label class="passive" href="#">Documents</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 app top64">
                    <div class="reg-form payment">
                        <div class="reg-completed">
                            <div class="form-group">
                                <div class="payment-box bt48">
                                    <h3>
                                        The payment is not approved. Refer to card issuer
                                    </h3>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm-12 submit-row">
                                    <router-link to="/prepayment">
                                        <button type="button" class="btn btn-primary">Try again</button>
                                    </router-link>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top16">
                        <img src="/images/auth-bird-768.jpg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopMenu from "./Menu";
    export default {
        components: { TopMenu },
        name: 'PaymentNotOK',

        data: () => ({
            model: {}
        }),
        mounted() {

        },
        computed: {

        },
        methods: {

        }
    }
</script>